export function createQuery(host,iface,type, durationStart = "-60m", durationEnd = "0m", durationInterval = "5m") {
    var query = "";
    if (type === 'snmp'){
         query = `
            incoming_bandwidth = from(bucket: "telegraf")
            |> range(start: ${durationStart}, stop: ${durationEnd})
            |> filter(fn: (r) => r["_measurement"] == "interface" and r["_field"] == "ifInUcastPkts")
            |> filter(fn: (r) => r["agent_host"] == "${host}" and r["ifDescr"] == "${iface}")
            |> derivative(unit: 1s)
            |> map(fn: (r) => ({
                _time: r._time,
                _field: "input_bps",
                 _value: (if r._value < 0.0 then -1.0 * float(v: r._value) else float(v: r._value)) // Convert bytes to bits per second
            }))
            |> aggregateWindow(every: ${durationInterval}, fn: mean, createEmpty: true)

            // OUTGOING Bandwidth Utilization
            outgoing_bandwidth = from(bucket: "telegraf")
            |> range(start: ${durationStart}, stop: ${durationEnd})
            |> filter(fn: (r) => r["_measurement"] == "interface" and r["_field"] == "ifOutUcastPkts")
            |> filter(fn: (r) => r["agent_host"] == "${host}" and r["ifDescr"] == "${iface}")
            |> derivative(unit: 1s)
            |> aggregateWindow(every: ${durationInterval}, fn: mean, createEmpty: true)
            |> map(fn: (r) => ({
                _time: r._time,
                _field: "output_bps",
                _value: (if r._value < 0.0 then -1.0 * float(v: r._value) else float(v: r._value)) // Convert bytes to bits per second
            }))

            union(tables: [incoming_bandwidth, outgoing_bandwidth])
            |> yield(name: "bwutil_bps")
            `

            return query;
        } 
 
    else {
        //    query = `
        //     from(bucket: "telegraf")
        //     |> range(start: ${durationStart}, stop: ${durationEnd})
        //     |> filter(fn: (r) => r["_measurement"] == "ezelink_interface_rx" or r["_measurement"] == "ezelink_interface_tx")
        //     |> filter(fn: (r) => r["type"] == "if_packets")
        //     |> filter(fn: (r) => r["host"] == "${host}")
        //     |> filter(fn: (r) => r["instance"] == "${iface}")
        //     |> aggregateWindow(every: ${durationInterval}, fn: mean, createEmpty: false)
        //     |> derivative(unit: 1s, nonNegative: true) // <-- this line gives you bytes/sec
        //     |> yield(name: "mean")
        //     `
        //     return query;
        query = `
            from(bucket: "telegraf")
            |> range(start: ${durationStart}, stop: ${durationEnd})
            |> filter(fn: (r) => r["_measurement"] == "ezelink_interface_rx" or r["_measurement"] == "ezelink_interface_tx")
            |> filter(fn: (r) => r["type"] == "if_packets")
            |> filter(fn: (r) => r["host"] == "${host}")
            |> filter(fn: (r) => r["instance"] == "${iface}")
            |> aggregateWindow(every: ${durationInterval}, fn: max, createEmpty: false)
            |> derivative(unit: 1s, nonNegative: true)
            `
            return query;
            
    }
}